import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAlgoliaComponent } from './simple-icons-algolia.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAlgoliaComponent ],
    exports:      [ SimpleIconsAlgoliaComponent ],
    bootstrap:    []
})
export class SimpleIconsAlgoliaModule {}
